import { ThunkDispatch } from 'redux-thunk';
import { IState } from '~/sharedInterfaces/IState';

// eslint-disable-next-line import/prefer-default-export
export const pushToGTM = (event: string | object) => {
  return (_: ThunkDispatch<any, any, any>, getState: () => IState) => {
    const { widgetContext } = getState();
    const baseEventPayload = {
      locale: widgetContext.locale,
      market: widgetContext.settings.market,
      language: widgetContext.settings.language,
      ...(widgetContext.clientId && { userId: widgetContext.clientId }),
      ...(widgetContext.cardApplicationId && { orderId: widgetContext.cardApplicationId }),
    };

    const data = typeof event === 'string' ? { event } : event;

    if (window.dataLayer && window.qredUseGtm) {
      try {
        window.dataLayer.push({ ...data, ...baseEventPayload });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};
